import { render, staticRenderFns } from "./Distribuidoras.vue?vue&type=template&id=006f38e8&scoped=true&"
import script from "./Distribuidoras.vue?vue&type=script&lang=js&"
export * from "./Distribuidoras.vue?vue&type=script&lang=js&"
import style0 from "./Distribuidoras.vue?vue&type=style&index=0&id=006f38e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f38e8",
  null
  
)

export default component.exports